<template>
    <div id="helpChapter" class="helpChapter app-inner">
         <!-- <div class="edit-header flex align-cen">
            <el-button plain @click="reback">上一步</el-button>
            <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load mft"
            @click="onSubmit"
            >
            保存</el-button>
        </div> -->
        <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
           <el-button type="primary" :loading="subloading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
            @click="onSubmit"
            >
                保存
           </el-button>
            </div>
        <div class="helpChapter-con edit-from">
         <div class="edit-from-tit">课程名称：{{paramsedit.num}} {{paramsedit.name}}  / {{paramsedit.cnum}} {{paramsedit.cname}} </div>
         <quill-editor
            class="editor"
            v-model="content"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @change="onEditorChange($event)"
            @ready="onEditorReady($event)"
            >
            </quill-editor>
        </div>
         <el-upload
                    v-show="false"
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
        >
         </el-upload>
          <!--视频上传弹窗-->
    <div>
      <el-dialog :close-on-click-modal="false" width="50%" style="margin-top: 1px" title="视频上传" :visible.sync="videoForm.show" append-to-body>
        <el-tabs v-model="videoForm.activeName">
          <el-tab-pane label="添加视频链接" name="first">
            <el-input v-model="videoForm.videoLink" placeholder="请输入视频链接" clearable></el-input>
            <el-button type="primary" size="small" style="margin: 20px 0px 0px 0px " @click="insertVideoLink(videoForm.videoLink)">确认
            </el-button>
          </el-tab-pane>
          <el-tab-pane label="本地视频上传" name="second">
            <el-upload v-loading="loading" style="text-align: center;" drag :action="$config.baseUrl + '/admin/sys-file/upload'" accept="video/*" 
             :headers="headers" :before-upload="onBeforeUploadVideo" 
             :on-success="onSuccessVideo" :on-error="onErrorVideo" 
             :on-progress="uploadVideoProcess"
             :multiple="false">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传视频文件，且不超过500M</div>
            </el-upload>
        <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </div>
    <canvas
      id="mycanvas"
      style="display: none"
    ></canvas>
         </div>
</template>
<script>
import LocaStorage from "../../../utils/localstorage.js" //本地存储公共方法
import {  chapterDetail } from "@/api/index/index"  //帮助基本信息详情
import {  helpEditor } from "@/api/index/index"  //帮助基本信息详情
import { quillEditor } from "vue-quill-editor";  //富文本编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import * as Quill from 'quill'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', ImageResize)
import Video from './quill-video.js'
Quill.register(Video, true)
import "./font.css";

var fonts = [
  "SimSun",
  "SimHei",
  "Microsoft-YaHei",
  "KaiTi",
  "FangSong",
  "Arial",
  "Times-New-Roman",
  "sans-serif",
];
// 自定义字号的大小，注意下面的内容要和css里面对应上
var sizes = [false, "16px", "18px", "20px", "22px", "26px", "28px", "30px"];
var Size = Quill.import("formats/size");
Size.whitelist = sizes;
var Font = Quill.import("formats/font");
Font.whitelist = fonts; //将字体加入到白名单
Quill.register(Font, true);
// toolbar标题
const titleConfig = [
  { Choice: '.ql-insertMetric', title: '跳转配置' },
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-header', title: '段落格式' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-blockquote', title: '块引用' },
  { Choice: '.ql-code', title: '插入代码' },
  { Choice: '.ql-code-block', title: '插入代码段' },
  { Choice: '.ql-font', title: '字体' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
  { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
  { Choice: '.ql-direction', title: '文本方向' },
  { Choice: '.ql-header[value="1"]', title: 'h1' },
  { Choice: '.ql-header[value="2"]', title: 'h2' },
  { Choice: '.ql-align', title: '对齐方式' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '图像' },
  { Choice: '.ql-video', title: '视频' },
  { Choice: '.ql-link', title: '添加链接' },
  { Choice: '.ql-formula', title: '插入公式' },
  { Choice: '.ql-clean', title: '清除字体格式' },
  { Choice: '.ql-script[value="sub"]', title: '下标' },
  { Choice: '.ql-script[value="super"]', title: '上标' },
  { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
  { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
  { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
  { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
  { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
  { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
  { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
  { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
  { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
  { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
  { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
  { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
  { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
  { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
  { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐' }
]

export default {
    name:'upContent',
    components: {
        quillEditor,
    },
     props: {
    /*编辑器的内容*/
    value: {
      type: String,
    },
    /*图片大小*/
    maxSize: {
      type: Number,
      default: 4000, //kb
    },
  },
    data (){
        let _self = this;
        return {
          subloading:false,
          loadProgress: 0, // 动态显示进度条
          progressFlag: false, // 关闭进度条
          qillInit: true,
            imgsrc:'',
            loading: false, 
             headers:{},
            paramsedit:{},
            options: [],
            content: "",
            quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
           // 富文本编辑器配置
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike','formula'], // 加粗 斜体 下划线 删除线
              ['blockquote', 'code-block'], // 引用  代码块
              [{ header: 1 }, { header: 2 }], // 1、2 级标题
              [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
              [{ script: 'sub' }, { script: 'super' }], // 上标/下标
              [{ indent: '-1' }, { indent: '+1' }], // 缩进
              [{ direction: 'rtl' }], // 文本方向
              [{ size: sizes }], // 字体大小
              [{ font: fonts }],
              [{ header: [1, 2, 3, 4, 5, 6] }], // 标题
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            
              [{ align: [] }], // 对齐方式
              ['clean'], // 清除文本格式
              ['image', 'video','link'] // 链接、图片、视频
            ],
            handlers: {
              'image': function (value) {
                if (value) { // value === true
                  document.querySelector('.avatar-uploader input').click()
                } else {
                  this.quill.format('image', false)
                }
              },
               'video': (value) => {
                // 覆盖默认的上传视频，点击视频图标，显示弹窗
                _self.videoForm.show = true
              }
            }
          },
          // 调整图片大小
     imageResize: {
         displayStyles: {
             backgroundColor: 'black',
             border: 'none',
             color: 'white'
         },
         modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
     }
        },
        placeholder: '请编辑文章内容'
      },
       // 视频上传变量
      videoForm: {
        show: false, // 显示插入视频链接弹框的标识
        videoLink: '',
        activeName: 'first'
      }
        }
    },
     mounted () {
    this.initTitle()
             if(this.$route.query.id){
       this.paramsedit =  JSON.parse(decodeURIComponent(this.$route.query.params))
       this.getDetail()
        }
  },
    created(){
        let token = LocaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
      // 视频上传进度
      uploadVideoProcess(event, file, fileList) {
          this.progressFlag = true; // 显示进度条
          this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
          if (this.loadProgress >= 100) {
              this.loadProgress = 100
              setTimeout( () => {this.progressFlag = false}, 1000) // 一秒后关闭进度条
          }
      },
        initTitle () {
      document.getElementsByClassName('ql-editor')[0].dataset.placeholder = ''
      for (let item of titleConfig) {
        let tip = document.querySelector('.quill-editor ' + item.Choice)
        if (!tip) continue
        tip.setAttribute('title', item.title)
      }
},

        onEditorReady(quill){
        },
         onEditorBlur() {
      //失去焦点事件
    },
    onEditorFocus(quill) {
      quill.enable(true) 
      //获得焦点事件
    },
  // 内容改变事件
  onEditorChange({ quill, html, text }) {
    this.content = html
// this.content为富文本现有的值
                    //富文本编辑器神坑处理
    // let quill = this.$refs.myQuillEditor.quill
    // let length = quill.selection.savedRange.index
  },
  handleAvatarSuccess(res, file){
      let quill = this.$refs.myQuillEditor.quill
      let length = quill.getSelection().index
      quill.insertEmbed(length, 'image', res.data.url)
      quill.setSelection(length + 1)
  },
   hideLoading () {
      this.loading = false
    },

      // el-文件上传组件
    onBeforeUploadVideo (file) {
      this.loading = true
      let acceptArr = [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
        ]
      const isVideo = acceptArr.includes(file.type)
      
      const isLt1M = file.size / 1024 / 1024 < 500
      if (!isVideo) {
        this.hideLoading()
        this.$message.error("请上传正确的视频格式")
      }
      if (!isLt1M) {
        this.hideLoading()
        this.$message.error('上传文件大小不能超过 500MB!')
      }
      return isLt1M && isVideo
    },
     onSuccessVideo (res) {
      this.hideLoading()
      if (res.code == 0) {
        this.insertVideoLink(res.data.url)
      } else {
        this.$message.error(res.msg)
      }
    },
      //截取视频第一帧作为播放前默认图片
    findvideocover(url) {
      const video = document.getElementsByClassName('ql-video'); // 获取视频对象
      // const video = document.createElement("video") // 也可以自己创建video
      video.src = url; // url地址 url跟 视频流是一样的
      var canvas = document.getElementById("mycanvas"); // 获取 canvas 对象
      const ctx = canvas.getContext("2d"); // 绘制2d
      video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
      video.currentTime = 1; // 第一帧
      video.oncanplay = () => {
        canvas.width = video.clientWidth; // 获取视频宽度
        canvas.height = video.clientHeight; //获取视频高度
        // 利用canvas对象方法绘图
        ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
        // 转换成base64形式
        this.imgsrc = canvas.toDataURL("image/png"); // 截取后的视频封面
      };
    },
           /** --------- 视频上传相关 start ---------  */
    insertVideoLink (videoLink) {
      if (!videoLink) return this.$message.error('视频地址不能为空！')
      this.findvideocover(videoLink)
      this.videoForm.show = false
      let quill = this.$refs.myQuillEditor.quill
      // // 获取富文本
      let range = quill.selection.savedRange.index
      // 获取光标位置：当编辑器中没有输入文本时，这里获取到的 range 为 null
      // 在光标所在位置 插入视频
       quill.insertEmbed(range, 'video', {
        url: videoLink,
        poster:this.imgsrc,
      })
      // 调整光标到最后
      quill.setSelection(range + 1)
    },
    
     // 文件上传失败时的钩子
    onErrorVideo () {
      this.hideLoading()
      this.$message.error('上传失败')
    },
            // 获取详情
        getDetail(){
              chapterDetail({
                id:this.paramsedit.cid
              })
            .then(res => {
               this.content = res.data.content
            })
            .catch(err => {
            })
        },
        // 下一步
        onSubmit(){
           this.subloading = true
                helpEditor({
                id:this.paramsedit.cid,
                content:this.content
              })
            .then(res => {
              this.subloading = false
               if(res.code == 0){
                this.$router.push({
                name: "upContent",
                query:{
                    id:this.$route.query.id,
                    state:this.$route.query.state
                }
           })
               }else{
                 this.$message.error(res.msg)
               }
            })
            .catch(err => {
               this.subloading = false
            })
        },

        // 返回
        reback(){
          this.$router.push({
            name: "upContent",
            query:{
                id:this.$route.query.id,
                state:this.$route.query.state
            }
           })
        },
    }
}
</script>
<style lang="scss" scoped>
#helpChapter{
    height: inherit;
    .edit-header{
        border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
        padding: 20px;

    }
      .edit-from{
         margin: 20px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
             color: #000;
         }
          .helpChapter-con-tit{
            padding: 10px 12px;
            background-color:#f7f7f7;
            margin-top: 20px;
            position: relative;
            .tit-ribbon{
                padding-left: 8px;
            }
            .tit-ribbon::before{
                content: '';
                background-color: #155bd4;
                width: 3px;
                height: 14px;
                position: absolute;
                top: 23px;
                left: 12px;
            }
          }
          .none-chapter{
            text-align: center;
            padding-top: 100px;
            i{
                font-size: 50px;
               
            }
          }
          .numlist-tit{
            padding: 0 14px;
            font-size: 16px;
            width: 100%;
            .mft{
                font-size: 13px;
                color: rgb(21, 91, 212);
                div{
                    cursor: pointer;
                    position: relative;
                }
                div:not(:last-child)::after{
                    content: "|";
                   color: #e5e5e5;
                   padding: 0 5px;
                }
                
            }
          }
          .childrenlist{
            padding: 10px 30px;
            margin-top: 10px;
            background: #f7f8fa;
            .childrenlist-tit{
                font-size: 14px;
            }
            .childrenlist-btn{
                padding-right: 5px;
              i{
                 margin-right: 10px;
                  font-size: 20px;
                  cursor: pointer;
              }
            }
          }
         }
}
    .forminfo{
        p{
            padding-left: 20px;
            color: #000;
        }
     .btn{
    width: 200px;
    height: 50px;
    background-color: #409eff;
    border-radius: 0.1vh;
    border: none;
    color: #fff;
    margin: 20px auto;
    margin-bottom: 0;;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
     }
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
  content: "12px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: "16px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: "20px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
  content: "22px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
  content: "24px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="26px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="26px"]::before {
  content: "26px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
  content: "28px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
  content: "30px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: "32px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="36px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="36px"]::before {
  content: "36px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="38px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="38px"]::before {
  content: "38px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="40px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="40px"]::before {
  content: "40px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="45px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="45px"]::before {
  content: "45px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="50px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="50px"]::before {
  content: "50px";
}
/**
设置默认字体显示
设置默认字体颜色
**/
.ql-container {
  font-size: 16px;
  color: black;
}
.btn-onsubmit {
  margin-top: 50px;
  text-align: center;
}
.btn-onsubmit .el-button {
  width: 30%;
}
.editor {
  line-height: normal !important;
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - 350px);
}
.ql-container {
  height: calc(100vh - 350px) !important;
}

.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
::v-deep {
    .ql-snow .ql-tooltip {
    left: 0 !important;
}
.ql-video{
    width: 100%;

}
.el-progress {
  width: 300px;
  margin: 0 auto;
}
}
</style>